import React from 'react';

import { notification, Button, Modal, Row, Col } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import * as actionsPersonas from '../../../actions/personas';
import * as actionsMain from '../../../actions/main';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TablaPersonas from './TablaPersonas';
import SumarPersona from './SumarPersona';

const confirm = Modal.confirm;

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

graphql(getUsuario);
class VerPersonas extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDescartar = () => {
    let yo = this;
    confirm({
      title: 'Realmente quiere descartar todo lo realizado?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props.actionsMain.reiniciar();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onSubmit = () => {
    this.props.onSubmit();
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log('Se desea eliminar la socio con id ', id);

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta socio?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props.actionsPersonas.sacarPersona(id);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  sacarSocio = idSocio => {
    //Este metodo es el encargado de realizar la llamada al servidor para sacar de la sociedad al socio eliminado.

    this.props
      .sacarSocio({
        variables: {
          idSociedad: this.props.sociedad._id,
          idSocio,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(respuestaSacar => {
        notification.warning({
          message: 'Persona eliminada',
          description: 'Se ha eliminado a la persona exitosamente',
        });
      })
      // eslint-disable-next-line no-unused-vars
      .catch(err => {
        Modal.error({
          title:
            'Error a la hora de remover el socio de la sociedad en la base de datos',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  confirmarAutorizacion = () => {};

  cargarPersona = () => {
    // console.log("ENTRE AL CARGAR PERSONA");
    // console.log(this.props.main);
    this.props.actionsMain.setCargaPersonas(
      !this.props.main.cargaPersonasToggle
    );
  };

  cambiarRolPersona = (persona, rol, index) => {
    // console.log(persona);
    // console.log(rol);
    // console.log(index);

    this.props.actionsPersonas.cambiarRolPorIndice(persona._id, rol, index);
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        {this.props.main.cargaPersonasToggle && <SumarPersona />}
        {!this.props.main.cargaPersonasToggle && (
          <div>
            <TablaPersonas
              cambiarRolPersona={this.cambiarRolPersona}
              personas={this.props.personas}
              history={this.props.history}
              onDelete={this.onDelete}
              cargarPersona={this.cargarPersona}
            />
            <Row>
              <Col span={10} offset={14}>
                <Button
                  type="danger"
                  icon={<Icons.EditOutlined />}
                  size="small"
                  style={{ width: 110, marginTop: 10, marginBottom: 10 }}
                  onClick={() => this.onDescartar()}
                >
                  {' '}
                  Descartar{' '}
                </Button>
                <Button
                  type="primary"
                  icon={<Icons.CheckOutlined />}
                  size="small"
                  style={{
                    width: 110,
                    marginLeft: 10,
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                  onClick={() => this.onSubmit()}
                >
                  {' '}
                  Confirmar{' '}
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPersonas: bindActionCreators(actionsPersonas, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerPersonas));
